import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaBoxOpen,
  FaMapMarkerAlt,
  FaClipboardList,
} from "react-icons/fa";
import { getUserByIdApi } from "../../../api/userService";
import Pagination from "../../Pagination/Pagination";
import RecordActions from "../../Shared/RecordActions";
import FullPageLoader from "../../../common/FullPageLoader";

export default function ViewUser() {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location?.state?.userId;
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  useEffect(() => {
    if (id) {
      fetchUser(currentPage);
    }
  }, [id, currentPage]);

  const fetchUser = async (page = 1) => {
    try {
      setLoading(true);

      const response = await getUserByIdApi(id, page);

      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <FullPageLoader text="Loading user..." />;
  }

  if (!user) {
    return (
      <div className="container-fluid p-4">
        <div className="card p-3 text-center">User not found</div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      <RecordActions onBack={() => navigate("/users")} />
      <div className="card p-3">
        <div className="row g-3 mb-3">
          <div className="col-md-3 mb-2 d-flex align-items-center gap-2">
            <FaUser className="text-muted" aria-hidden="true" />
            <span>{user.name || "N/A"}</span>
          </div>

          <div className="col-md-3 mb-2 d-flex align-items-center gap-2">
            <FaEnvelope className="text-muted" aria-hidden="true" />
            <span>{user.email || "N/A"}</span>
          </div>

          <div className="col-md-3 mb-2 d-flex align-items-center gap-2">
            <FaPhone className="text-muted" aria-hidden="true" />
            <span>{user.phone || "N/A"}</span>
          </div>

          <div className="col-md-3 mb-2 d-flex align-items-center gap-2">
            <FaBoxOpen className="text-muted" aria-hidden="true" />
            <span>{user?.orders?.data?.length || 0}</span>
          </div>
        </div>

        <div className="mb-3">
          <h5 className="mb-3 text-dark fw-bold d-flex align-items-center gap-2">
            <FaMapMarkerAlt className="text-muted" aria-hidden="true" />
            <span>Addresses</span>
          </h5>

          {user?.addresses?.length > 0 ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Receiver Name</th>
                  <th>Receiver No</th>
                  <th>Address</th>
                  <th>Primary</th>
                </tr>
              </thead>

              <tbody>
                {user.addresses.map((address, index) => (
                  <tr key={address._id}>
                    <td>{index + 1}</td>
                    <td>{address.receiverName}</td>
                    <td>{address.receiverNo}</td>

                    <td>
                      {address.addressLine1}
                      {address.addressLine2 ? `, ${address.addressLine2}` : ""}
                      {address.landMark ? `, ${address.landMark}` : ""}
                    </td>
                    <td>{address.isPrimary ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No Addresses Found</p>
          )}
        </div>

        <div className="">
          <h5 className="mb-3 text-dark fw-bold d-flex align-items-center gap-2">
            <FaClipboardList className="text-muted" aria-hidden="true" />
            <span>Orders</span>
          </h5>

          {user?.orders?.data?.length > 0 ? (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Product Name</th>
                    <th>Text</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Size</th>
                    <th>Material</th>
                    <th>Font</th>
                    <th>Color</th>
                  </tr>
                </thead>

                <tbody>
                  {user.orders.data.map((order) =>
                    order.items.map((item, index) => (
                      <tr key={`${order._id}-${index}`}>
                        <td>{order.orderId}</td>
                        <td>{item.name}</td>
                        <td>{item.customText}</td>
                        <td>{item.quantity}</td>
                        <td>₹{item.price}</td>
                        <td>{item.selections?.sizeId?.value || "-"}</td>
                        <td>{item.selections?.materialId?.value || "-"}</td>
                        <td>{item.selections?.fontId?.value || "-"}</td>
                        <td>{item.selections?.colorId?.name || "-"}</td>
                      </tr>
                    )),
                  )}
                </tbody>
              </table>
              <Pagination
                totalItems={user?.orders?.pagination?.total || 0}
                itemsPerPage={user?.orders?.pagination?.limit || 10}
                currentPage={user?.orders?.pagination?.page || 1}
                onPageChange={(page) => {
                  setCurrentPage(page);
                }}
              />
            </>
          ) : (
            <p>No Orders Found</p>
          )}
        </div>
      </div>
    </div>
  );
}
